/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FaultInfo, FaultToUpdateInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FaultClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Fault
   * @summary Получить все разломы
   * @request GET:/Seismic/Fault
   * @secure
   */
  faultGetAllFaults = (params: RequestParams = {}) =>
    this.http.request<FaultInfo[], any>({
      path: `/Seismic/Fault`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Добавить новые разломы
   * @request POST:/Seismic/Fault
   * @secure
   */
  faultAddFault = (data: FaultInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/Seismic/Fault`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Изменить существующий разлом
   * @request PUT:/Seismic/Fault
   * @secure
   */
  faultUpdateFault = (data: FaultToUpdateInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/Seismic/Fault`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Получить разлом по Id
   * @request GET:/Seismic/Fault/{faultId}
   * @secure
   */
  faultGetFaultById = (faultId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo, any>({
      path: `/Seismic/Fault/${faultId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Fault
 * @summary Получить базовый разлом по Id.
Если разлом не имеет базового, то возвращается он сам
 * @request GET:/Seismic/Fault/{faultId}/base
 * @secure
 */
  faultGetBaseFaultByFaultId = (faultId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo, any>({
      path: `/Seismic/Fault/${faultId}/base`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Fault
 * @summary Получить данные разлома в домене Z
Домен TWT хранится на стороне сейсмики
 * @request GET:/Seismic/Fault/zippedData/{faultId}
 * @secure
 */
  faultGetFaultZippedDataById = (faultId: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/Seismic/Fault/zippedData/${faultId}`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Получить разломы по Id месторождения
   * @request GET:/Seismic/Fault/field/{fieldId}
   * @secure
   */
  faultGetFaultsByFieldId = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo[], any>({
      path: `/Seismic/Fault/field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Получить разломы по id группы
   * @request GET:/Seismic/Fault/group/{groupId}
   * @secure
   */
  faultGetFaultsByGroupId = (groupId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo[], any>({
      path: `/Seismic/Fault/group/${groupId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Fault
   * @summary Экспорт разлома в формате charisma
   * @request GET:/Seismic/Fault/{faultId}/export/chm
   * @secure
   */
  faultExportFaultToCharisma = (faultId: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/Seismic/Fault/${faultId}/export/chm`,
      method: 'GET',
      secure: true,
      ...params,
    })
}
